import React, { useContext, useEffect, useState } from 'react'
import { MdOutlineArrowOutward } from 'react-icons/md';
import { humanReadableTimePassed } from '../../Helper/calculations';
import { BASE_URL_API } from '../../References/URLs';
import AuthContext from '../../Store/AuthContext';
import styles from './PointsHistory.module.css'

const PointsHistory = () => {
    const authCtx = useContext(AuthContext)
    const loginData = JSON.parse(authCtx.loginData)
    const [redemptionHistory, setRedemptionHistory] = useState([])

    const getPointsLedger = async () => {
        try {
            const response = await fetch(BASE_URL_API + "getPointsLedger", {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    userIdentifier: loginData?.userIdentifier,
                }),
            });

            const result = await response.json();
            if (result.status === "success") {
                setRedemptionHistory(result.response);
            } else {
                if (result.message === "token Expired, please login again!") {
                    authCtx.logout();
                }
            }
        } catch (error) {
            console.error("Error fetching order history:", error);
        }
    };

    useEffect(() => {
        getPointsLedger()
    }, []);

    return (
        <div className={styles.mainWrapper}>
            <div className={styles.section}>
                <div className={styles.header} >Points Transactions History</div>
                <div className={styles.bodyWrapper}>
                    <div>

                    </div>
                    <div>
                        {redemptionHistory.length > 0 ? (
                            <div>
                                {
                                    redemptionHistory.map((redemption) => (
                                        <div key={redemption.id} className={styles.redemptionItem}>
                                            <div className={styles.transactionType}>
                                                {redemption.transactionType === "CREDIT" ?
                                                    <div className={styles.creditIcon}>
                                                        <MdOutlineArrowOutward size={28} />
                                                    </div>
                                                    :
                                                    <div className={styles.debitIcon} >
                                                        <MdOutlineArrowOutward size={28} />
                                                    </div>
                                                }
                                            </div>
                                            <div className={styles.pointsValue}>{redemption.pointsValue}</div>
                                            <div className={styles.transactionDoneOn}>
                                                {redemption.transactionDoneOn}
                                                <div className={styles.timeAgo}>
                                                    {humanReadableTimePassed(redemption?.transactionDoneOn)}
                                                </div>
                                            </div>
                                            <div className={styles.remarks}>
                                                {redemption.remarks}
                                            </div>
                                            {redemption.status}
                                        </div>
                                    ))
                                }
                                <div className={styles.thatsAll}>That's All</div>
                            </div>
                        ) : (
                            <p>No redemptions found.</p>
                        )}
                    </div>
                </div>
            </div>
        </div >
    )
}

export default PointsHistory